import { createNewsletterSubscribeHandlers } from "@server/playdata-newsletter"
import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

const handlers = createNewsletterSubscribeHandlers()

export const Route = createFileRoute("/api/playdata/newsletter/subscribe")(
  serverRouteConfig({
    server: {
      handlers,
    },
  })
)
